import React, { useCallback, useState } from "react";
import * as Scrivito from "scrivito";
import { getHomepage, getPageLink, getPageObj } from "utils";
import { useTranslate } from "hooks";
import { useIsAuthenticated, useUserActions } from "stores/user";
import { Button } from "../Button";

export const LogoutButton = Scrivito.connect(({ isGray = false }) => {
  const translate = useTranslate();
  const [error, setError] = useState<Error | null>(null);

  const homepage = getHomepage();
  const homepageId = homepage?.id();

  const userActions = useUserActions();
  const isAuthenticated = useIsAuthenticated();

  const handleLogOut = useCallback(async () => {
    try {
      if (homepageId) await userActions.logout();
    } catch (err) {
      console.error(err);
      setError(err instanceof Error ? err : new Error(String(err)));
    }
  }, [homepageId, userActions]);

  const parentObj = getPageObj("LoginPage");

  return (
    <>
      {error && <div className="text-danger">{translate("ERROR_LOGOUT")}</div>}
      {isAuthenticated ? (
        <Button
          data-testid="NavRightSidebar_logout-btn"
          color={isGray ? "secondary" : "primary"}
          size="lg"
          onClick={handleLogOut}
        >
          {translate("LEAVE_TROX_CONFIGURATOR")}
        </Button>
      ) : (
        <Scrivito.LinkTag
          data-testid="nav-right-sidebar_login-link"
          to={getPageLink(parentObj as Scrivito.Obj) as Scrivito.Obj}
          className="py-3 rounded-1 bg-blue-300 text-center text-uppercase text-decoration-none text-white"
        >
          {homepage?.get("configuratorNavLogin") as string}
        </Scrivito.LinkTag>
      )}
    </>
  );
});
